import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { removeUser, Remove_User } from "../Redux/Kanhaiya/action";
import { useNavigate } from "react-router-dom";

import "./Navbar.css";
import { AuthContext } from "../Context/AuthContext";

const UserDropdown = ({ username }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { logoutUser } = React.useContext(AuthContext);
  const open = Boolean(anchorEl);
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          maxHeight: "20px",
          marginTop: "10px",
        }}
      >
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            //   sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <p style={{ color: "white", fontSize: "16px", fontWeight: "500" }}>
              {username}{" "}
              {anchorEl ? (
                <i
                  style={{ marginLeft: "10px" }}
                  class="fa-solid fa-angle-up"
                ></i>
              ) : (
                <i class="fa-solid fa-angle-down"></i>
              )}{" "}
            </p>
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            color: "white",
            background: "#121212",
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 20,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              // bgcolor: 'background.paper',
              bgcolor: "black",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem>
          <Avatar /> Profile
        </MenuItem>
        <MenuItem>
          <Avatar /> My account
        </MenuItem>
        <Divider />
        <MenuItem>
          <ListItemIcon>
            <PersonAdd sx={{ color: "white" }} fontSize="small" />
          </ListItemIcon>
          Add another account
        </MenuItem>
        <MenuItem>
          <ListItemIcon>
            <Settings sx={{ color: "white" }} fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        {/* <MenuItem onClick={()=>{dispatch(removeUser(false)); localStorage.clear();  navigate("/signi")}}> */}
        <MenuItem
          onClick={() => {
            logoutUser();
            localStorage.clear();
            navigate("/signi");
          }}
        >
          <ListItemIcon>
            <Logout sx={{ color: "white" }} fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default UserDropdown;
